module.exports = __webpack_public_path__ + "img/pr-2.38591847.png";